import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Brotkrumen" className="mb-6" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-slate-300">
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={14} className="text-terra" />}
          {i < items.length - 1 ? <Link to={it.path} className="hover:text-white">{it.name}</Link> : <span aria-current="page" className="text-white">{it.name}</span>}
        </li>
      ))}
    </ol>
  </nav>
);
